module.exports = "<p>\n  calendar-popup works!\n</p>\n"